import { Injectable } from '@angular/core';
import { Http } from '../shared/http-client/http-client.component';
import 'rxjs/add/operator/map';
import { Observable } from "rxjs/Observable";
import { EnvironmentSpecificService } from "../../environment-specific.service";
import { AppSocket } from '../../app.module';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class MapServices {

    apiUrl:any;
    appUrl:any;
    developmentEnv:boolean = true;
    constructor(private _http: Http,
        private _envService: EnvironmentSpecificService,
        private _appSocket: AppSocket,
        private _toastr: ToastrService) {

        this.apiUrl = this._envService.envSpecific.apiUrl;
        this.appUrl = this._envService.envSpecific.appUrl;
        this.developmentEnv = this._envService.envSpecific.developmentEnv;

    }

    RequestStartGPS(id){

        this._appSocket.emit("RequestStartGPS",id);
    }

    RequestStopGPS(id){

        this._appSocket.emit("RequestStopGPS",id);
    }

    RequestStartGPSTracking(id){

        this._appSocket.emit("RequestStartGPSTracking",id);
    }

    RequestStopGPSTracking(id){

        this._appSocket.emit("RequestStopGPSTracking",id);
    }

    // QTEL-875: explicit-only activity log. Called from the Realtime Tracking toggle (onTrackClick)
    // on Map / Communication / Live View. Request*GPSTracking now only controls the GPS stream.
    AddStartLocationTracking(id){

        this._appSocket.emit("AddStartLocationTracking",id);
    }

    AddStopLocationTracking(id){

        this._appSocket.emit("AddStopLocationTracking",id);
    }

    MapDisconnect(){

        this._appSocket.emit("mapdisconnect");
    }

    
    RequestLastLocation(id){

        this._appSocket.emit("RequestLastLocation",id);
    }

    AttachMapListener = () =>{
        return Observable.create((observer) => {

            if (this._appSocket.ioSocket._callbacks['$ResponseLastLocation'])  this._appSocket.removeListener('ResponseLastLocation');
            this._appSocket.on('ResponseLastLocation', (message) => {
                observer.next({type:'ResponseLastLocation',data: JSON.parse(message)});
            });

            if (this._appSocket.ioSocket._callbacks['$ResponseRealtimeGPS'])  this._appSocket.removeListener('ResponseRealtimeGPS');
            this._appSocket.on('ResponseRealtimeGPS', (message) => {
                observer.next({type:'ResponseRealtimeGPS',data: JSON.parse(message)});
            });
         
        });
    }

    ReleaseMapListener(){
        if (this._appSocket.ioSocket._callbacks['$ResponseLastLocation'])  this._appSocket.removeListener('ResponseLastLocation');
        if (this._appSocket.ioSocket._callbacks['$ResponseRealtimeGPS'])  this._appSocket.removeListener('ResponseRealtimeGPS');
    }

    GetListDevices(): Observable<any>{
        return this._http.get(this.apiUrl + '/users/listdevices').map((response: Response) => {
            return response;
        });
    }

    GetLocationAddress(data:any): Observable<any> {
        return this._http.post(this.appUrl + '/api/gps/getlocationaddress',data).map((response: Response) => {
            return response;
        });
    }

}